"use client";

import { useState, useContext, useEffect, useRef } from "react";
import { ErpContext } from "../../context/ErpContext.js";
import { useParams } from "react-router-dom";
import { useTenantNavigation } from "../../hooks/useTenantNavigation";
//import AddBoxIcon from '@material-ui/icons/AddBox';

import {
  IconButton,
  TextField,
  Button,
  Autocomplete,
  Collapse,
  Modal,
  Typography,
  Box,
  Grid,
  Divider,
  Stack,
  Card,
  CardContent,
  alpha,
  Chip,
} from "@mui/material";

import { Close as CloseIcon } from "@mui/icons-material";
import { red, green } from "@mui/material/colors";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import DeleteIcon from "@mui/icons-material/Delete";
import PersonAddAltIcon from "@mui/icons-material/PersonAddAlt";
import AddShoppingCartIcon from "@mui/icons-material/AddShoppingCart";
import ReceiptIcon from "@mui/icons-material/Receipt";
import PersonIcon from "@mui/icons-material/Person";
import SearchIcon from "@mui/icons-material/Search";
import PaymentIcon from "@mui/icons-material/Payment";
import dayjs from "dayjs";

import "./GestionGenerarVentaComponent.css";

import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableFooter from "@mui/material/TableFooter";

import ModalFacturaComponent from "./ModalFacturaComponent.js";

import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import Inventory2Icon from "@mui/icons-material/Inventory2";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#5b5b5f",
    color: theme.palette.common.white,
    fontWeight: 600,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
  "&:hover": {
    backgroundColor: alpha(theme.palette.primary.light, 0.1),
    transition: "background-color 0.2s ease",
  },
}));

const EditarCompraComponent = () => {
  const { idTransaccionEditarCompra, idEstado } = useParams();
  const navigate = useTenantNavigation();

  const {
    getItemTresLetras,
    itemTresLetras,
    postTransaccionItem,
    postTransaccion,
    getTipoEntidad,
    tipoEntidades,
    tipoMedioDePago,
    getTipoMedioDePago,
    updateItemUbicacion,
    postCrearPago,
    postTransaccionPago,
    getMedioDePagoIdTipoEspecifico,
    medioDePagoIdTipoEspecifico,
    getCuentaCorriente,
    getCuentaCorrienteByIdEntidad,
    postCuentaCorriente,
    updateCuentaCorriente,
    cuentasCorrientes,
    getItemUbicacionFilter,
    getItemProveedor,
    updateItemProveedor,
    postItemProveedor,
    entidadesTipoEntidad,
    getEntidadByTipoEntidad,
    getUbicacion,
    ubicaciones,
    getNegocio,
    negocios,
    getItemUbicacionFilterByUbicacion,
    getListaMontosByIdItemIdEntidad,
    getPrecioLista,
    getEstadoCompra,
    postTransaccionCompraEstado,
    getTransaccionFilter,
    getEntidadByID,
    getTransaccionItemsByTransactionId,
    getItemById,
    updateTransaccionItem,
    deleteTransaccionItem,
    deleteTransaccionCompraItem,
    getTransaccionItemIDEnCompras,
    postTransaccionCompraItem,
    putTransaccion,
    updateTransaccionCompraEstado,
    isNavbarCollapsed,
  } = useContext(ErpContext);

  const [descripcionTransaccion, setDescripcionTransaccion] = useState("");
  const [selectedItem, setSelectedItem] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [filteredItems, setFilteredItems] = useState([]);

  // Lista unificada de ítems (existentes y nuevos)
  const [itemList, setItemList] = useState([]);
  const [transaccionItems, setTransaccionItems] = useState([]);
  const [transaccionCompraItems, setTransaccionCompraItems] = useState([]);

  const [cantidadTransaccionItem, setCantidadTransaccionItem] = useState("");
  const [dniProveedor, setDniProveedor] = useState("");

  const [precioTotal, setPrecioTotal] = useState(0);
  const [cantidadItemsSelect, setCantidadItemsSelect] = useState(0);
  const [cantidadItemsInvocados, setCantidadItemsInvocados] = useState(0);

  const [entidadExistente, setEntidadExistente] = useState(null);
  const [abrirModalCrearCliente, setAbrirModalCrearCliente] = useState(false);
  const [abrirModalEntidadCliente, setAbrirModalEntidadCliente] =
    useState(false);

  const [entidadAEditar, setEntidadAEditar] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [transaccionData, setTransaccionData] = useState(null);
  const [entidadFactura, setEntidadFactura] = useState([]);

  /* LOGICA MODAL MEDIO DE PAGO*/
  const [openModalMedioPago, setOpenModalMedioPago] = useState(false);

  /*Variables Medio de pago*/
  const [modalMedioDePagoSeleccionadoID, setModalMedioDePagoSeleccionadoID] =
    useState(null);
  const [
    modalTipoMedioDePagoSeleccionado,
    setModalTipoMedioDePagoSeleccionado,
  ] = useState(null);
  const [modalMedioDePagoSeleccionado, setModalMedioDePagoSeleccionado] =
    useState(null);
  const [modalMedioDePagoCantidad, setModalMedioDePagoCantidad] =
    useState(null);
  const [medioDePagoList, setMedioDePagoList] = useState([]);

  const [selectedTipoMedioDePago, setSelectedTipoMedioDePago] = useState(null);
  const [selectedMedioDePago, setSelectedMedioDePago] = useState([]);
  const [openCollapse, setOpenCollapse] = useState(false);

  const [mostrarButtonModalMedioPago, setMostrarButtonModalMedioPago] =
    useState(false);

  const [cantidaMedioDePagoList, setCantidaMedioDePagoList] = useState(0);

  const [selectedUbicacion, setSelectedUbicacion] = useState(null);
  const [selectedNegocio, setSelectedNegocio] = useState(null);

  const [proveedorSeleccionado, setProveedorSeleccionado] = useState(false);

  const [estadoDeCompra, setEstadoDeCompra] = useState([]);

  const [successMessage, setSuccessMessage] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);

  const [loading, setLoading] = useState(true);
  const [existingPayments, setExistingPayments] = useState([]);
  const [totalPaid, setTotalPaid] = useState(0);

  const [deletedItems, setDeletedItems] = useState([]);

  const [refreshMode, setRefreshMode] = useState(false);

  // Nueva función para actualizar "A recibir"
  const handleUpdateARecibir = (index, newARecibir) => {
    try {
      const updatedItems = [...itemList];
      updatedItems[index].aRecibir = Number(newARecibir);
      setItemList(updatedItems);
    } catch (error) {
      console.error("Error actualizando la cantidad a recibir:", error);
    }
  };

  // Actualiza la cantidad (orden) y recalcula "a recibir" en función de lo recibido
  const handleUpdateItemPorCantidad = async (index, newCantidad) => {
    try {
      const updatedItems = [...itemList];
      updatedItems[index].cantidad = Number(newCantidad);
      // Recalcular "a recibir" = Orden - Recibidos
      updatedItems[index].aRecibir =
        Number(newCantidad) - Number(updatedItems[index].cantidadRecibida);
      setItemList(updatedItems);
      // Recalcular subtotal
      await recalcSubtotal();
    } catch (error) {
      console.error("Error actualizando el item:", error);
    }
  };

  useEffect(() => {
    if (selectedTipoMedioDePago) {
      if (selectedTipoMedioDePago.id === 7) {
        setOpenCollapse(false);
        setMostrarButtonModalMedioPago(true);
        setOpenModalMedioPago(true);
      } else {
        getMedioDePagoIdTipoEspecifico(selectedTipoMedioDePago);
        setMostrarButtonModalMedioPago(false);
        setOpenCollapse(true);
      }
    } else {
      setOpenCollapse(false);
      setOpenModalMedioPago(false);
      setMedioDePagoList([]);
    }

    if (modalTipoMedioDePagoSeleccionado) {
      getMedioDePagoIdTipoEspecifico(modalTipoMedioDePagoSeleccionado);
    }
  }, [selectedTipoMedioDePago, modalTipoMedioDePagoSeleccionado]);

  useEffect(() => {
    setItemList([]);
  }, [selectedUbicacion]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);

        console.log(idTransaccionEditarCompra);

        if (idTransaccionEditarCompra) {
          // Cargar datos básicos
          await getTipoEntidad();
          await getTipoMedioDePago();
          await getEntidadByTipoEntidad(2); // Cargar proveedores (tipo entidad 2)
          await getUbicacion();
          await getNegocio();

          // Obtener la transacción
          const transaccionFiltrada = await getTransaccionFilter(
            idTransaccionEditarCompra
          );
          console.log("Transacción filtrada:", transaccionFiltrada);

          // Obtener la entidad (proveedor)
          const entidadFiltrada = await getEntidadByID(
            transaccionFiltrada.idEntidad
          );

          // Configurar la ubicación y negocio
          const defaultUbicacion = ubicaciones.find(
            (it) => it.id === transaccionFiltrada.idUbicacion
          );
          const defaultNegocio = negocios.find(
            (it) => it.id === transaccionFiltrada.idNegocio
          );

          // Obtener los ítems de transacción y compra
          const items = await getTransaccionItemIDEnCompras(
            idTransaccionEditarCompra
          );
          console.log(items.items);
          console.log(items.compraItems);
          setTransaccionItems(items.items);
          setTransaccionCompraItems(items.compraItems);

          if (defaultUbicacion) {
            setSelectedUbicacion({
              id: defaultUbicacion.id,
              label: defaultUbicacion.descripcion,
            });
          }

          if (defaultNegocio) {
            setSelectedNegocio({
              id: defaultNegocio.id,
              label: defaultNegocio.descripcion,
            });
          }

          // Configurar el proveedor
          const proveedorEncontrado = entidadesTipoEntidad.find(
            (ent) => ent.id === entidadFiltrada.id
          );
          if (proveedorEncontrado) {
            setDniProveedor({
              label: `${proveedorEncontrado.descripcion} - ${proveedorEncontrado.apellido} - ${proveedorEncontrado.dniCuitCuil}`,
              descripcion: proveedorEncontrado.descripcion,
              apellido: proveedorEncontrado.apellido,
              id: proveedorEncontrado.id,
              dniCuitCuil: proveedorEncontrado.dniCuitCuil,
            });
            setProveedorSeleccionado(true);
          }

          setPrecioTotal(transaccionFiltrada.montoTotal);

          // Procesar pagos existentes
          if (
            transaccionFiltrada.transaccionPago &&
            transaccionFiltrada.transaccionPago.length > 0
          ) {
            const pagosExistentes = transaccionFiltrada.transaccionPago.map(
              (tp) => ({
                id: tp.idPago,
                descripcion: tp.pago.medioDePago.descripcion,
                monto: tp.pago.montoTotal,
                tipoMedioDePago: tp.pago.medioDePago.tipoMedioDePago?.id || 1,
              })
            );

            setExistingPayments(pagosExistentes);

            const montoTotalPagado = pagosExistentes.reduce(
              (total, pago) => total + pago.monto,
              0
            );
            setTotalPaid(montoTotalPagado);
            setCantidaMedioDePagoList(montoTotalPagado);
          }

          // Obtener los ítems de la transacción
          const transaccionItems = items.items;
          console.log("Ítems de la transacción:", transaccionItems);

          // Mapear los ítems con la información completa e incluir la columna "aRecibir"
          const itemsCompletos = await Promise.all(
            transaccionItems.map(async (item) => {
              const itemById = await getItemById(item.idItem);

              // Obtener stock actual
              const ubicacionItem = await getItemUbicacionFilterByUbicacion(
                item.idItem,
                transaccionFiltrada.idUbicacion
              );

              // Buscar el ítem correspondiente en compraItems (se usa totalCantidadRecibida y fechaMasRecibiente)
              const compraItem = items.compraItems.find(
                (ci) => ci.idItem === item.idItem
              ) || {
                totalCantidadRecibida: 0,
                fechaMasRecibiente: null,
              };

              const stockActual =
                ubicacionItem.length > 0 ? ubicacionItem[0].inventario : 0;

              const stockMin = ubicacionItem?.length
                ? ubicacionItem[0]?.stockMinimo
                : 0;

              // Agregamos el campo "aRecibir" que por defecto es: Orden - Recibidos (pero no menor a 0)
              const orden = item.cantidad;
              const recibidos = compraItem.totalCantidadRecibida || 0;
              const aRecibirDefault =
                orden - recibidos > 0 ? orden - recibidos : 0;

              return {
                ...item,
                descripcion:
                  itemById?.descripcion || "Descripción no disponible",
                codigo: itemById?.codigo || "Código no disponible",
                stock: stockActual,
                idUbicacion: transaccionFiltrada.idUbicacion,
                ubicacion:
                  defaultUbicacion?.descripcion || "Ubicación no disponible",
                isExisting: true, // Marcar como ítem existente
                costo: item.precio, // Asegurar que costo y precio sean consistentes
                precio: item.precio,
                cantidadRecibida: recibidos,
                totalCantidadRecibida: recibidos,
                stockMin: stockMin, //Este se agrega para cuando se hace el update de items, para reutilizar la funcion del controller que pase ya el stockMin que tenia.
                // "Orden" es la cantidad pedida originalmente (ya está en item.cantidad)
                aRecibir: aRecibirDefault, //iba aRecibirDefault pero vamos hacer que venga 0
                updatedAt: compraItem.fechaMasRecibiente || null,
              };
            })
          );

          setItemList(itemsCompletos);
          setCantidadItemsSelect(
            itemsCompletos.reduce((total, item) => total + item.cantidad, 0)
          );
          setCantidadItemsInvocados(itemsCompletos.length);
        }
      } catch (error) {
        console.error("Error al cargar los datos de la transacción:", error);
        withReactContent(Swal).fire({
          position: "bottom-end",
          icon: "error",
          text: "Error al cargar los datos de la compra",
          showConfirmButton: false,
          timer: 3000,
          width: 300,
        });
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // useEffect para manejar la lógica de búsqueda
  useEffect(() => {
    if (searchText.length >= 3) {
      getItemTresLetras(searchText);
    } else {
      setFilteredItems([]);
    }
  }, [searchText]);

  // useEffect para actualizar el total
  useEffect(() => {
    const updatedTotal = itemList.reduce(
      (total, item) => total + item.cantidad * item.costo,
      0
    );
    setPrecioTotal(updatedTotal);
    setCantidadItemsSelect(
      itemList.reduce((total, item) => total + item.cantidad, 0)
    );
    setCantidadItemsInvocados(itemList.length);
  }, [itemList]);

  const handleAbrirModalMedioDePago = () => {
    setOpenModalMedioPago(true);
  };

  const handleDeleteMedioDePago = (medioDePago, medioDePagoMonto) => {
    setCantidaMedioDePagoList((prevTotal) => prevTotal - medioDePagoMonto);
    setMedioDePagoList(medioDePagoList.filter((_, i) => i !== medioDePago));
  };

  const handleAddNuevoMedioDePago = () => {
    if (modalMedioDePagoSeleccionado && modalMedioDePagoCantidad) {
      const newMedioDePago = {
        id: modalMedioDePagoSeleccionadoID,
        descripcion: modalMedioDePagoSeleccionado,
        monto: Number.parseFloat(modalMedioDePagoCantidad),
        tipoMedioDePago: modalTipoMedioDePagoSeleccionado.id,
      };

      setMedioDePagoList([...medioDePagoList, newMedioDePago]);

      const updatedTotalMedioPagoList = [
        ...medioDePagoList,
        newMedioDePago,
      ].reduce((total, item) => total + item.monto, 0);

      setCantidaMedioDePagoList(totalPaid + updatedTotalMedioPagoList);
      setModalMedioDePagoSeleccionado("");
      setModalMedioDePagoSeleccionadoID(null);
      setModalMedioDePagoCantidad("");
    }
  };

  const handleProveedorSeleccionado = (event, newValue) => {
    if (newValue) {
      setDniProveedor(newValue);
      setProveedorSeleccionado(true);
    } else {
      setDniProveedor(null);
      setProveedorSeleccionado(false);
      setSelectedItem(null);
      setCantidadTransaccionItem("");
    }
  };

  // 1. Agregar estados y funciones para los modales de confirmación
  // Añadir después de la línea donde se declara [isReadOnly, setIsReadOnly]

  const [estadoCompraTexto, setEstadoCompraTexto] = useState("");
  const [estadoCompraColor, setEstadoCompraColor] = useState("");
  const [showIncompleteModal, setShowIncompleteModal] = useState(false);
  const [showClosedModal, setShowClosedModal] = useState(false);
  const [showClosedConfirmModal, setShowClosedConfirmModal] = useState(false);

  const estadoCompraGlobal = useRef(1); // Se actualiza de forma inmediata y no provoca re-render

  // Función para marcar como incompleta
  /*const handleMarkIncomplete = async () => {
    try {
      estadoCompraGlobal = 2
      await updateTransaccionCompraEstado(idTransaccionEditarCompra, 2) // INCOMPLETA
      withReactContent(Swal).fire({
        position: "bottom-end",
        icon: "success",
        text: "Compra marcada como INCOMPLETA",
        showConfirmButton: false,
        timer: 3000,
        width: 300,
      })
      // Actualizar el estado local
      setIsReadOnly(true)
      setEstadoCompraTexto("INCOMPLETA")
      setEstadoCompraColor(red[500])
    } catch (error) {
      console.error("Error al marcar como incompleta:", error)
      withReactContent(Swal).fire({
        position: "bottom-end",
        icon: "error",
        text: "Error al cambiar el estado de la compra",
        showConfirmButton: false,
        timer: 3000,
        width: 300,
      })
    }
  }*/

  // Función para marcar como cerrada
  const handleMarkClosed = async () => {
    try {
      let stockSatisfecho = false;
      let estaPagado = false;
      stockSatisfecho = itemList.every(
        (item) => (item.cantidadRecibida || 0) >= item.cantidad
      );
      estaPagado = totalPaid >= precioTotal;

      if (stockSatisfecho && estaPagado) {
        // Caso: Compra Cerrada
        estadoCompraGlobal.current = 3; // Actualiza el estado global
        await updateTransaccionCompraEstado(idTransaccionEditarCompra, 3); // CERRADA
      } else {
        // Caso: Compra Incompleta
        estadoCompraGlobal.current = 2; // Actualiza el estado global
        await updateTransaccionCompraEstado(idTransaccionEditarCompra, 2); // INCOMPLETA

        // Se muestra el miniModal para solicitar la descripción
        const { value: descripcionInput } = await withReactContent(Swal).fire({
          title: "Tu transacción va a ser Incompleta",
          text: "Por favor, ingresa una descripción:",
          input: "textarea", // Usamos un textarea en lugar de un input simple
          inputPlaceholder: "Escribe aquí...",
          inputAttributes: {
            // Estilos iniciales: altura mínima, altura máxima, sin scroll (se activa luego)
            style:
              "min-height: 150px; max-height: 300px; overflow-y: hidden; resize: none;",
          },
          showCancelButton: true,
          inputValidator: (value) => {
            if (!value) {
              return "La descripción es obligatoria";
            }
            return null;
          },
          // Cuando se abre el modal, agregamos un listener para autoajustar la altura
          didOpen: () => {
            const input = Swal.getInput();
            if (input) {
              input.addEventListener("input", function () {
                // Se resetea la altura para recalcular el scrollHeight
                this.style.height = "auto";
                // Si la altura natural es menor a 300px, se ajusta sin scroll
                if (this.scrollHeight < 300) {
                  this.style.overflowY = "hidden";
                  this.style.height = this.scrollHeight + "px";
                } else {
                  // En caso de superar la altura máxima, se fija y se activa el scroll vertical
                  this.style.overflowY = "auto";
                  this.style.height = "300px";
                }
              });
            }
          },
        });

        // Si se ingresó una descripción, se actualiza la transacción con esa información
        if (descripcionInput !== undefined) {
          await putTransaccion(
            idTransaccionEditarCompra, // idTransaccion
            precioTotal, // montoTotal
            2, // idTipoTransaccion (COMPRA)
            dniProveedor.id, // idEntidad
            1, // idSubCategoriaTransaccion
            descripcionInput, // descripcion (texto ingresado)
            1, // idUsuario (valor numérico, ajusta según corresponda)
            selectedUbicacion.id, // idUbicacion
            selectedNegocio.id, // idNegocio
            0, // montoDescuento
            0 // porcentajeDescuento
          );
        }

        // Continuación de la lógica para actualizar las cuentas corrientes
        const cuentas = await getCuentaCorrienteByIdEntidad(dniProveedor.id);
        const cuenta = cuentas.find((ct) => ct.idEntidad === dniProveedor.id);
        if (estaPagado && !stockSatisfecho) {
          // Caso: Está pagado pero el stock no se completó
          let totalPendiente = 0;
          for (const item of itemList) {
            if ((item.cantidadRecibida || 0) < item.cantidad) {
              const pendiente =
                item.cantidad * item.precio -
                item.cantidadRecibida * item.precio;
              totalPendiente += pendiente;
            }
          }
          const montoNegativo = totalPendiente;
          if (cuenta) {
            await updateCuentaCorriente(dniProveedor.id, montoNegativo, 2);
          } else {
            await postCuentaCorriente(dniProveedor.id, montoNegativo, 2);
          }
        } else if (!estaPagado && stockSatisfecho) {
          // Caso: No está pagado pero el stock se cumplió
          const deber = precioTotal - totalPaid;
          if (cuenta) {
            await updateCuentaCorriente(dniProveedor.id, deber, 2);
          } else {
            await postCuentaCorriente(dniProveedor.id, deber, 2);
          }
        } else {
          // Caso: No está pagado y el stock no se completó
          let totalPendiente = 0;
          for (const item of itemList) {
            if ((item.cantidadRecibida || 0) < item.cantidad) {
              const pendiente = item.cantidadRecibida * item.precio;
              totalPendiente += pendiente;
            }
          }
          const montoDeudor = totalPendiente - totalPaid;
          if (cuenta) {
            if (montoDeudor > 0) {
              await updateCuentaCorriente(
                dniProveedor.id,
                montoDeudor,
                2
              );
            } else {
              await updateCuentaCorriente(dniProveedor.id, montoDeudor, 2);
            }
          } else {
            if (montoDeudor > 0) {
              await postCuentaCorriente(dniProveedor.id, montoDeudor, 2);
            } else {
              await postCuentaCorriente(dniProveedor.id, montoDeudor, 2);
            }
          }
        }
      }

      // Modal de éxito
      withReactContent(Swal).fire({
        position: "bottom-end",
        icon: "success",
        text: `Compra marcada como ${
          stockSatisfecho && estaPagado ? "CERRADA" : "INCOMPLETA"
        }`,
        showConfirmButton: false,
        timer: 3000,
        width: 300,
      });
      // Actualizar el estado local
      setIsReadOnly(true);
      setEstadoCompraTexto("CERRADA");
      setEstadoCompraColor(green[500]);
    } catch (error) {
      console.error("Error al marcar como cerrada:", error);
      withReactContent(Swal).fire({
        position: "bottom-end",
        icon: "error",
        text: "Error al cambiar el estado de la compra",
        showConfirmButton: false,
        timer: 3000,
        width: 300,
      });
    }
  };

  // 3. Modificar la función handleTransaccionSubmit para incluir la lógica de confirmación
  // Reemplazar la función handleTransaccionSubmit completa
  const enviarHandlePagos = async () => {
    handleTransaccionSubmit("pagos");
  };
  const enviarHandleStock = async () => {
    handleTransaccionSubmit("stock");
  };

  const handleTransaccionSubmit = async (dato) => {
    try {
      // 1. ¿Stock completo?
      const stockSatisfecho = itemList.every(
        (item) =>
          (item.cantidadRecibida || 0) + (item.aRecibir || 0) >= item.cantidad
      );

      // 2. ¿Pagado completo?
      let estaPagado = false;
      const restante = precioTotal - totalPaid;

      if (selectedTipoMedioDePago?.id === 7) {
        // Múltiples medios de pago → la suma debe cubrir el restante
        const sumaMedios = medioDePagoList.reduce(
          (total, item) => total + item.monto,
          0
        );
        estaPagado = sumaMedios >= restante;
      } else if (selectedMedioDePago != "") {
        console.log("Medio de pago seleccionado:", selectedMedioDePago);
        // Medio único → se da por hecho que cubre el restante
        estaPagado = true;
        console.log("Pagada. Estado: CERRADA");
      } else {
        // Sin selección nueva, validamos solo con pagos previos
        estaPagado = totalPaid >= precioTotal;
        console.log("totalPaid:", totalPaid, "precioTotal:", precioTotal);
      }

      if (dato == "pagos") {
        await procesarTransaccion(dato);
      } else {
        await procesarTransaccion(dato);
      }

      // Si no cumple las condiciones para ser cerrada, continuar con el proceso normal
    } catch (error) {
      console.error("Error al actualizar la transacción:", error);
      withReactContent(Swal).fire({
        position: "bottom-end",
        icon: "error",
        text: "Error al actualizar la compra",
        showConfirmButton: false,
        timer: 3000,
        width: 300,
      });
    } finally {
      setRefreshMode(true);
      navigate(
        `RefreshRedirect/${idTransaccionEditarCompra}/${estadoCompraGlobal.current}`
      );
    }
  };

  // 4. Agregar la función para procesar la transacción
  // Añadir después de handleTransaccionSubmit

  const procesarTransaccion = async (dato, cerrarCompra = false) => {
    try {
      const today = dayjs();
      let suma = 0;

      // Separar ítems existentes y nuevos
      if (dato == "stock") {
        const itemsExistentes = itemList.filter((item) => item.isExisting);
        const itemsNuevos = itemList.filter((item) => !item.isExisting);

        // Actualizar ítems existentes
        for (const item of itemsExistentes) {
          await updateTransaccionItem(idTransaccionEditarCompra, item.idItem, {
            cantidad: item.cantidad,
            precio: item.costo,
            porcentajeDescuento: 0,
          });
          //Si hay un cambio en lo que se le pidio al proveedor.

          await postTransaccionCompraItem(
            today,
            idTransaccionEditarCompra,
            item.idItem,
            item.aRecibir,
            item.costo,
            0
          ); //Updatea el itemCompraItem mostrando el ultimo ingreso de stock ya entregado por el proveedor

          await updateItemUbicacion(
            item.idItem,
            item.idUbicacion,
            item.aRecibir,
            "compra"
          ); //Actualiza los itemUbicacion con los ya ingresados - SE LE AGREGA "compra" PORQUE ES PARA DESCONTAR EL ITEM SE UTILIZA EL MISMO CONTROLLER PARA SUMAR O DESCONTRAR DEPENDIENDO DEL HARDCODED COMPRA VENTA
        }

        // Crear ítems nuevos
        for (const item of itemsNuevos) {
          await postTransaccionItem(
            idTransaccionEditarCompra,
            item.idItem,
            item.cantidad,
            item.costo,
            0
          );

          await postTransaccionCompraItem(
            today,
            idTransaccionEditarCompra,
            item.idItem,
            item.aRecibir,
            item.costo,
            0
          );

          await updateItemUbicacion(
            item.idItem,
            item.idUbicacion,
            item.aRecibir,
            "compra"
          ); //Actualiza los itemUbicacion con los ya ingresados
        }

        // Eliminar ítems eliminados
        for (const deletedItem of deletedItems) {
          console.log("Eliminando ítem:", deletedItem);
          await deleteTransaccionItem(
            idTransaccionEditarCompra,
            deletedItem.idItem
          );

          await deleteTransaccionCompraItem(
            idTransaccionEditarCompra,
            deletedItem.idItem
          );
        }

        // Actualizar transacción principal
        await putTransaccion(
          idTransaccionEditarCompra,
          precioTotal,
          2, // idTipoTransaccion (COMPRA)
          dniProveedor.id, // idEntidad
          1, //idSubCategoriaTransaccion
          "", // descripcion
          descripcionTransaccion,
          1, // idUsuario (ajustar según corresponda)
          selectedUbicacion.id,
          selectedNegocio.id,
          0,
          0
        );
      }
      console.log(dato);
      if (dato == "pagos") {
        const itemsExistentes = itemList.filter((item) => item.isExisting);

        //Verificamos si restante es 0
        const restante = precioTotal - totalPaid;
  // Actualizar ítems existentes
        for (const item of itemsExistentes) {
          await updateTransaccionItem(idTransaccionEditarCompra, item.idItem, {
            cantidad: item.cantidad,
            precio: item.costo,
            porcentajeDescuento: 0,
          });
          //Si hay un cambio en lo que se le pidio al proveedor.
        }

        if (restante > 0) {
          console.log(dato);
          // Procesar medios de pago
          if (selectedTipoMedioDePago) {
            console.log(
              "Tipo de medio de pago seleccionado. ID del tipo de medio de pago:",
              selectedTipoMedioDePago
            );
            if (selectedTipoMedioDePago.id === 7) {
              console.log(
                "Medio de pago multiple seleccionado. ID del medio de pago:"
              );
              for (const it of medioDePagoList) {
                const transaccionCrearPago = await postCrearPago(
                  1,
                  1,
                  it.id,
                  it.monto
                );
                suma += it.monto;

                // Verificar si el tipo de medio de pago afecta cuenta corriente usando el flag
                const tipoMedio = tipoMedioDePago.find(t => t.id === it.tipoMedioDePago)
                if (tipoMedio?.afectaCuentaCorriente === true) {
                  const cuentas = await getCuentaCorrienteByIdEntidad(
                    dniProveedor.id
                  );
                  const cuenta = cuentas.find(
                    (ct) => ct.idEntidad === dniProveedor.id
                  );

                  if (cuenta) {
                    await updateCuentaCorriente(
                      dniProveedor.id,
                      it.monto,
                      2
                    );
                  } else {
                    await postCuentaCorriente(
                      dniProveedor.id,
                      it.monto,
                      2
                    );
                  }
                }

                await postTransaccionPago(
                  idTransaccionEditarCompra,
                  transaccionCrearPago.data.id
                );
              }
            } else if (selectedMedioDePago) {
              console.log(
                "Medio de pago único seleccionado. ID del medio de pago:"
              );
              const montoAPagar = restante > 0 ? restante : precioTotal;

              const transaccionCrearPago = await postCrearPago(
                1,
                1,
                selectedMedioDePago.id,
                montoAPagar
              );

              // Verificar si el tipo de medio de pago afecta cuenta corriente usando el flag
              if (selectedTipoMedioDePago?.afectaCuentaCorriente === true) {
                const cuentas = await getCuentaCorrienteByIdEntidad(
                  dniProveedor.id
                );
                const cuenta = cuentas.find(
                  (ct) => ct.idEntidad === dniProveedor.id
                );

                if (cuenta) {
                  await updateCuentaCorriente(
                    dniProveedor.id,
                    montoAPagar,
                    2
                  );
                } else {
                  await postCuentaCorriente(
                    dniProveedor.id,
                    montoAPagar,
                    2
                  );
                }
              }

              await postTransaccionPago(
                idTransaccionEditarCompra,
                transaccionCrearPago.data.id
              );
              suma = montoAPagar;
            }
          }
        }
      }

      // === Determinar estado final ===
      const estadoActualCompra = estadoDeCompra.find(
        (estado) => estado.idTransaccion === Number(idTransaccionEditarCompra)
      );

      if (estadoActualCompra?.idEstadoCompra === 2) {
        console.log(
          "Transacción ya está marcada como INCOMPLETA. Estado no modificado."
        );
      } else if (cerrarCompra) {
        console.log("Usuario eligió cerrar la compra. Estado: CERRADA");
        estadoCompraGlobal.current = 3; // Actualiza el estado global
        await updateTransaccionCompraEstado(idTransaccionEditarCompra, 3); // CERRADA
      } else {
        // 2. ¿Pagado completo?
        let estaPagado = false;
        const restante = precioTotal - totalPaid;

        if (selectedTipoMedioDePago?.id === 7) {
          // Múltiples medios de pago → la suma debe cubrir el restante
          const sumaMedios = medioDePagoList.reduce(
            (total, item) => total + item.monto,
            0
          );
          estaPagado = sumaMedios >= restante;
        } else if (selectedMedioDePago != "") {
          // Medio único → se da por hecho que cubre el restante
          console.log("Pagada. Estado: CERRADA");
          estaPagado = true;
        } else {
          // Sin selección nueva, validamos solo con pagos previos
          console.log("Resta de pagos");
          estaPagado = totalPaid >= precioTotal;
          console.log("totalPaid:", totalPaid, "precioTotal:", precioTotal);
        }
        // 1. ¿Stock completo?
        let stockSatisfecho = false;
        if (dato == "stock") {
          stockSatisfecho = itemList.every(
            (item) =>
              (item.cantidadRecibida || 0) + (item.aRecibir || 0) >=
              item.cantidad
          );
        }
        if (dato == "pagos") {
          stockSatisfecho = itemList.every(
            (item) => (item.cantidadRecibida || 0) >= item.cantidad
          );
        }

        if (!estaPagado && !stockSatisfecho) {
          console.log("No pagada y stock incompleto. Estado: ABIERTA");
          estadoCompraGlobal.current = 1;
          await updateTransaccionCompraEstado(idTransaccionEditarCompra, 1); // ABIERTA
        } else if (!estaPagado && stockSatisfecho) {
          console.log("No pagada. Estado: SALDO PENDIENTE");
          estadoCompraGlobal.current = 4;
          await updateTransaccionCompraEstado(idTransaccionEditarCompra, 4); // SALDO PENDIENTE
        } else if (estaPagado && !stockSatisfecho) {
          console.log("Pagada pero stock incompleto. Estado: SALDO CERRADO");
          estadoCompraGlobal.current = 5;
          await updateTransaccionCompraEstado(idTransaccionEditarCompra, 5); // SALDO CERRADO
        } else if (estaPagado && stockSatisfecho) {
          // Usamos SweetAlert2 para esperar la respuesta del usuario
          const MySwal = withReactContent(Swal);
          const result = await MySwal.fire({
            title: "Confirmar cierre",
            text: "La compra cumple los requisitos para ser cerrada. ¿Desea cerrarla ahora?",
            icon: "question",
            showCancelButton: true,
            confirmButtonText: "Cerrar compra",
            cancelButtonText: "No cerrar",
          });

          // Si el usuario cancela, detenemos la función (o realizamos otra acción)
          if (!result.isConfirmed) {
            estadoCompraGlobal.current = 1; // Actualiza el estado global
            // Por ejemplo, llamamos a una función para dejarla en estado "sin cerrar"
            await convertirSinCerrar();
            return; // Salimos de la función
          } else {
            estadoCompraGlobal.current = 3; // Actualiza el estado global
            // El usuario confirmó: procedemos a cerrar la compra
            await cerrarLaCompra();
          }
        }
      }

      withReactContent(Swal).fire({
        position: "bottom-end",
        icon: "success",
        text: "Compra actualizada correctamente",
        showConfirmButton: false,
        timer: 3000,
        width: 300,
      });
    } catch (error) {
      console.error("Error al actualizar la transacción:", error);
      withReactContent(Swal).fire({
        position: "bottom-end",
        icon: "error",
        text: "Error al actualizar la compra",
        showConfirmButton: false,
        timer: 3000,
        width: 300,
      });
    }
  };

  const convertirSinCerrar = async () => {
    estadoCompraGlobal.current = 1; // Actualiza el estado global
    updateTransaccionCompraEstado(idTransaccionEditarCompra, 1); // ABIERTA
  };
  const cerrarLaCompra = async () => {
    estadoCompraGlobal.current = 3; // Actualiza el estado global
    await updateTransaccionCompraEstado(idTransaccionEditarCompra, 3); //CERRADA
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleAddItem = async () => {
    if (selectedItem && cantidadTransaccionItem) {
      try {
        // Obtener el precio de lista según el proveedor seleccionado
        const precioListaItem = await getListaMontosByIdItemIdEntidad(
          dniProveedor.id,
          selectedItem.id,
          selectedUbicacion.id
        );

        const ubicacionItemProveedor = await getItemProveedor(
          selectedItem.id,
          dniProveedor.id
        );
        const ubicacionItem = await getItemUbicacionFilterByUbicacion(
          selectedItem.id,
          selectedUbicacion.id
        );

        // Usar el precio de lista si existe, de lo contrario usar el costo del proveedor
        const costoProveedor = precioListaItem
          ? precioListaItem.monto
          : ubicacionItemProveedor?.costo || 0;
        const stockDisponible = ubicacionItem?.length
          ? ubicacionItem[0]?.inventario
          : "No disponible";
        const stockMin = ubicacionItem?.length
          ? ubicacionItem[0]?.stockMinimo
          : 0;

        // Verificar si el ítem ya existe en itemList
        const existingItemIndex = itemList.findIndex(
          (it) =>
            it.idItem === selectedItem.id &&
            it.idUbicacion === selectedUbicacion.id
        );

        if (existingItemIndex !== -1) {
          // Si el ítem existe, actualiza su "orden" y recalcula "a recibir"
          await handleUpdateItemPorCantidad(
            existingItemIndex,
            Number(itemList[existingItemIndex].cantidad) +
              Number(cantidadTransaccionItem)
          );
        } else {
          // Crear el nuevo ítem
          const newItem = {
            descripcion: selectedItem.descripcion,
            cantidad: Number(cantidadTransaccionItem), // Orden solicitada
            cantidadRecibida: 0, // Inicialmente no se ha recibido nada
            aRecibir: Number(cantidadTransaccionItem), //iba aRecibirDefault pero vamos hacer que venga 0
            stock: stockDisponible,
            costo: costoProveedor,
            codigo: selectedItem.codigo,
            porcentajeDescuento: 0,
            idItem: selectedItem.id,
            precio: costoProveedor,
            idUbicacion: selectedUbicacion.id,
            ubicacion: selectedUbicacion.label,
            stockMin: stockMin, //Este se agrega para cuando se hace el update de items, para reutilizar la funcion del controller que pase ya el stockMin que tenia.
            isExisting: false, // Marcar como ítem nuevo
            updatedAt: new Date().toISOString(),
          };

          const updatedItems = [...itemList, newItem];
          setItemList(updatedItems);
          await recalcSubtotal();
        }

        // Resetea los campos
        setSelectedItem(null);
        setCantidadTransaccionItem("");
        if (autocompleteRef.current) {
          autocompleteRef.current.focus();
        }
      } catch (error) {
        console.error("Error al agregar el ítem:", error);
      }
    }
  };

  const handleUpdateItemPorCosto = (index, newCosto) => {
    try {
      const updatedItems = [...itemList];
      updatedItems[index].costo = Number(newCosto);
      updatedItems[index].precio = Number(newCosto);
      setItemList(updatedItems);
      recalcSubtotal();
    } catch (error) {
      console.error("Error actualizando el costo del item:", error);
    }
  };

  // Eliminar ítem individual
  const handleDeleteItem = (index) => {
    const itemToRemove = itemList[index];

    // Función auxiliar para eliminar el ítem: agrega el ítem eliminado a deletedItems y lo remueve de itemList
    const removeItem = () => {
      setDeletedItems((prev) => [...prev, itemToRemove]);
      setItemList((prev) => prev.filter((_, i) => i !== index));
    };

    // Si es un ítem existente, se pide confirmación antes de eliminar
    if (itemToRemove.isExisting) {
      withReactContent(Swal)
        .fire({
          title: "¿Está seguro?",
          text: "Este ítem ya existe en la compra. ¿Desea eliminarlo?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sí, eliminar",
          cancelButtonText: "Cancelar",
        })
        .then((result) => {
          if (result.isConfirmed) {
            removeItem();
          }
        });
    } else {
      // Si es un ítem nuevo, eliminar directamente usando removeItem
      removeItem();
    }
  };

  // Eliminar todos los ítems
  const handleDeleteAllItems = () => {
    // Verificar si hay ítems existentes
    const hasExistingItems = itemList.some((item) => item.isExisting);

    if (hasExistingItems) {
      withReactContent(Swal)
        .fire({
          title: "¿Está seguro?",
          text: "Hay ítems existentes en la lista. ¿Desea eliminar todos los ítems?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sí, eliminar todos",
          cancelButtonText: "Cancelar",
        })
        .then((result) => {
          if (result.isConfirmed) {
            setItemList([]);
          }
        });
    } else {
      setItemList([]);
    }
  };

  const handleCloseModalMedioPago = () => {
    setOpenModalMedioPago(false);
  };

  // Función para recalcular el subtotal basado en la lista actual de ítems
  const recalcSubtotal = async () => {
    const updatedTotal = itemList.reduce(
      (total, item) => total + item.cantidad * item.costo,
      0
    );
    setPrecioTotal(updatedTotal);

    // Si tienes un endpoint para actualizar la transacción, puedes llamarlo aquí:
    // await updateTransaccion({ id: idTransaccionEditarCompra, montoTotal: updatedTotal });
  };

  const autocompleteRef = useRef(null);
  const cantidadRef = useRef(null);
  const buttonRef = useRef(null);

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      if (document.activeElement === buttonRef.current) {
        autocompleteRef.current.focus();
      } else {
        buttonRef.current.focus();
      }
    }
  };

  const handleKeyDownAndSubmit = (event) => {
    handleKeyDown(event);
    if (event.key === "Enter") {
      handleAddItem();
    }
  };

  const [isReadOnly, setIsReadOnly] = useState(false);
  const [showModal, setShowModal] = useState(false);

  // Cuando se carga el componente, verificamos si el estado es incompleta (2) o cerrada (3)
  // 2. Modificar el useEffect para establecer el estado de la compra
  // Reemplazar el useEffect que verifica el estado

  useEffect(() => {
    console.log("Estado de la compra:", idEstado);
    if (idEstado == 2) {
      setIsReadOnly(true);
      setEstadoCompraTexto("INCOMPLETA");
      setEstadoCompraColor("red");
    } else if (idEstado == 3) {
      setIsReadOnly(true);
      setEstadoCompraTexto("CERRADA");
      setEstadoCompraColor("green");
    }
    if (idEstado == 4) {
      setEstadoCompraTexto("SALDO PENDIENTE");
      setEstadoCompraColor("blue");
    }
    if (idEstado == 5) {
      setEstadoCompraTexto("STOCK PENDIENTE");
      setEstadoCompraColor("blue");
    }
    if (idEstado == 1) {
      setEstadoCompraTexto("ABIERTA");
      setEstadoCompraColor("orange");
    }
  }, [idEstado]);

  // Función para abrir el modal al presionar el botón
  const handleIncompleteClick = () => {
    setShowModal(true);
  };

  // Función que se ejecuta si se confirma en el modal
  const handleConfirmIncomplete = () => {
    setShowModal(false);
    // Se ejecuta la función que marca la compra como incompleta
    //handleMarkIncomplete();
  };

  // 5. Modificar el return para agregar los modales y botones
  // Reemplazar la línea que contiene "Editar Compra #" con:

  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <Typography>Cargando datos de la compra...</Typography>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        backgroundColor: "#f5f5f5",
        position: "relative",
        padding: 2,
      }}
    >
      <form
        onSubmit={(e) => {
          e.preventDefault();
          //handleTransaccionSubmit();
        }}
      >
        <Grid container spacing={2}>
          {/* Left Column - Products */}
          <Grid item xs={12} md={9}>
            <Card elevation={3} sx={{ mb: 2, borderRadius: 2 }}>
              <CardContent>
                {/* 1. Eliminar los botones de marcar incompleta y cerrada de la parte superior
                // Modificar el Box que contiene el título y los botones */}
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    mb: 2,
                  }}
                >
                  <Typography
                    variant="h6"
                    sx={{ display: "flex", alignItems: "center" }}
                  >
                    <ReceiptIcon sx={{ mr: 1, color: "rgb(244, 177, 14)" }} />
                    Editar Compra #{idTransaccionEditarCompra}
                    {estadoCompraTexto && (
                      <Chip
                        label={estadoCompraTexto}
                        sx={{
                          ml: 2,
                          backgroundColor: (estadoCompraColor, 0.1),
                          color: estadoCompraColor,
                          fontWeight: "bold",
                          border: `1px solid ${estadoCompraColor}`,
                        }}
                      />
                    )}
                  </Typography>
                </Box>

                {/* Selector de proveedor */}
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    mb: 2,
                    gap: 1,
                    p: 1,
                    borderRadius: 1,
                  }}
                >
                  <Autocomplete
                    size="small"
                    fullWidth
                    disablePortal
                    disabled={isReadOnly}
                    options={entidadesTipoEntidad.map((it) => ({
                      label: `${it.descripcion} - ${it.apellido} - ${it.dniCuitCuil}`,
                      descripcion: it.descripcion,
                      apellido: it.apellido,
                      id: it.id,
                      dniCuitCuil: it.dniCuitCuil,
                    }))}
                    value={dniProveedor}
                    onChange={handleProveedorSeleccionado}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Proveedor - DNI / CUIT / CUIL"
                        InputProps={{
                          ...params.InputProps,
                          startAdornment: (
                            <>
                              <PersonIcon
                                color="action"
                                sx={{ ml: 1, mr: 0.5 }}
                              />
                              {params.InputProps.startAdornment}
                            </>
                          ),
                        }}
                        disabled={isReadOnly}
                      />
                    )}
                  />
                  <IconButton
                    onClick={() => console.log("Agregar nuevo proveedor")}
                    disabled={isReadOnly}
                    sx={{ color: "rgb(244, 177, 14)" }}
                  >
                    <PersonAddAltIcon />
                  </IconButton>
                </Box>

                {/* Búsqueda y adición de productos */}
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    mb: 2,
                    gap: 1,
                    backgroundColor: alpha("#f5f5f5", 0.5),
                    p: 1,
                    borderRadius: 1,
                    flexWrap: "wrap",
                  }}
                >
                  <Autocomplete
                    size="small"
                    disablePortal
                    disabled={!proveedorSeleccionado || isReadOnly}
                    options={(itemTresLetras || []).map((it) => ({
                      label: `${it.codigo} - ${it.descripcion}`,
                      descripcion: it.descripcion,
                      codigo: it.codigo,
                      id: it.id,
                    }))}
                    value={selectedItem}
                    onChange={(event, newValue) => {
                      setSelectedItem(newValue);
                      if (newValue) {
                        cantidadRef.current.focus();
                      }
                    }}
                    onInputChange={(event, newInputValue) =>
                      setSearchText(newInputValue)
                    }
                    sx={{ flexGrow: 1 }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Buscar producto"
                        InputProps={{
                          ...params.InputProps,
                          startAdornment: (
                            <>
                              <SearchIcon
                                color="action"
                                sx={{ ml: 1, mr: 0.5 }}
                              />
                              {params.InputProps.startAdornment}
                            </>
                          ),
                        }}
                        inputRef={autocompleteRef}
                        onKeyDown={handleKeyDown}
                        disabled={isReadOnly}
                      />
                    )}
                  />
                  <TextField
                    size="small"
                    label="Cantidad"
                    variant="outlined"
                    value={cantidadTransaccionItem}
                    onChange={(e) => setCantidadTransaccionItem(e.target.value)}
                    inputRef={cantidadRef}
                    onKeyDown={handleKeyDown}
                    disabled={!proveedorSeleccionado || isReadOnly}
                    sx={{ width: 100 }}
                  />
                  <Button
                    variant="contained"
                    onClick={handleAddItem}
                    ref={buttonRef}
                    onKeyDown={handleKeyDownAndSubmit}
                    startIcon={<AddShoppingCartIcon />}
                    disabled={!proveedorSeleccionado || isReadOnly}
                    sx={{ backgroundColor: "#5b5b5f", color: "white" }}
                  >
                    Agregar
                  </Button>
                  <Box sx={{ display: "flex", gap: 1 }}>
                    <Autocomplete
                      size="small"
                      disablePortal
                      disabled={isReadOnly}
                      options={ubicaciones.map((it) => ({
                        id: it.id,
                        label: it.descripcion,
                      }))}
                      value={selectedUbicacion}
                      onChange={(event, newValue) => {
                        setSelectedUbicacion(newValue);
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Ubicación"
                          size="small"
                          sx={{ width: 150 }}
                          disabled={isReadOnly}
                        />
                      )}
                    />
                    <Autocomplete
                      size="small"
                      disablePortal
                      disabled={isReadOnly}
                      options={negocios.map((it) => ({
                        id: it.id,
                        label: it.descripcion,
                      }))}
                      value={selectedNegocio}
                      onChange={(event, newValue) => {
                        setSelectedNegocio(newValue);
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Negocio"
                          size="small"
                          sx={{ width: 150 }}
                          disabled={isReadOnly}
                        />
                      )}
                    />
                  </Box>
                </Box>
              </CardContent>
            </Card>

            {/* Tabla unificada de productos */}
            <Card elevation={3} sx={{ borderRadius: 2, overflow: "hidden" }}>
              <TableContainer sx={{ maxHeight: 400 }}>
                <Table stickyHeader>
                  {/* 2. Modificar la tabla para eliminar la columna "Satisfacción" y mover los iconos junto al TextField de "A recibir"
                  // Primero, modificar los encabezados de la tabla */}
                  <TableHead>
                    <TableRow>
                      <StyledTableCell>Producto</StyledTableCell>
                      <StyledTableCell align="right">Orden</StyledTableCell>
                      <StyledTableCell align="right">Recibidos</StyledTableCell>
                      <StyledTableCell align="right">A recibir</StyledTableCell>
                      <StyledTableCell align="right">
                        Última Actualización
                      </StyledTableCell>
                      <StyledTableCell align="right">
                        Costo Unit.
                      </StyledTableCell>
                      <StyledTableCell align="right">Total</StyledTableCell>
                      <StyledTableCell align="center">Acciones</StyledTableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {itemList.length > 0 ? (
                      itemList.map((it, index) => {
                        // Calcular si el ítem está satisfecho: cuando (recibidos + aRecibir) es igual a la orden
                        const totalRecibir =
                          Number(it.cantidadRecibida) +
                          Number(it.aRecibir || 0);
                        const isSatisfied = totalRecibir === it.cantidad;
                        const satisfactionStatus = isSatisfied
                          ? "Satisfecha"
                          : "Insatisfecha";
                        const statusColor = isSatisfied ? green[500] : red[500];

                        // Formatear la fecha de actualización
                        const updatedAt = it.updatedAt
                          ? new Date(it.updatedAt).toLocaleString()
                          : "No disponible";

                        return (
                          <StyledTableRow
                            key={index}
                            sx={
                              it.isExisting
                                ? { backgroundColor: "transparent !important" }
                                : {
                                    backgroundColor:
                                      "rgba(173, 216, 230, 0.8) !important",
                                  }
                            }
                          >
                            <TableCell>
                              <Typography variant="body2" fontWeight="medium">
                                {it.codigo} - {it.descripcion}
                              </Typography>
                            </TableCell>
                            <TableCell align="right">
                              <StyledTableCell align="right">
                                <TextField
                                  type="number"
                                  value={it.cantidad}
                                  size="small"
                                  onChange={(e) =>
                                    handleUpdateItemPorCantidad(
                                      index,
                                      e.target.value
                                    )
                                  }
                                  sx={{ width: 80 }}
                                  disabled={isReadOnly}
                                />
                              </StyledTableCell>
                            </TableCell>
                            <TableCell align="right">
                              <Typography variant="body2" fontWeight="medium">
                                {it.cantidadRecibida || 0}
                              </Typography>
                            </TableCell>
                            {/* Ahora, modificar las celdas de la tabla para mover el icono junto al TextField */}
                            <TableCell align="right">
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "flex-end",
                                  gap: 1,
                                }}
                              >
                                <TextField
                                  type="number"
                                  value={
                                    it.aRecibir !== undefined
                                      ? it.aRecibir
                                      : it.cantidad - it.cantidadRecibida
                                  }
                                  size="small"
                                  onChange={(e) =>
                                    handleUpdateARecibir(index, e.target.value)
                                  }
                                  sx={{ width: 80 }}
                                  disabled={isReadOnly}
                                />
                                {isSatisfied ? (
                                  <CheckCircleIcon sx={{ color: green[500] }} />
                                ) : (
                                  <Inventory2Icon sx={{ color: "orange" }} />
                                )}
                              </Box>
                            </TableCell>
                            <TableCell align="right">
                              <Typography
                                variant="body2"
                                color="text.secondary"
                                fontSize="0.75rem"
                              >
                                {updatedAt}
                              </Typography>
                            </TableCell>
                            <TableCell align="right">
                              <TextField
                                type="number"
                                defaultValue={it.costo || 0}
                                size="small"
                                onBlur={(e) =>
                                  handleUpdateItemPorCosto(
                                    index,
                                    e.target.value
                                  )
                                }
                                sx={{
                                  width: 100,
                                  "& .MuiInputBase-root": {
                                    borderRadius: 1,
                                  },
                                }}
                                InputProps={{ startAdornment: <span>$</span> }}
                                disabled={isReadOnly}
                              />
                            </TableCell>
                            <TableCell align="right">
                              <Typography fontWeight="medium">
                                {new Intl.NumberFormat("es-AR", {
                                  style: "currency",
                                  currency: "ARS",
                                }).format(it.costo * it.cantidad)}
                              </Typography>
                            </TableCell>
                            <TableCell align="center">
                              <IconButton
                                color="error"
                                size="small"
                                onClick={() => handleDeleteItem(index)}
                                disabled={isReadOnly}
                              >
                                <DeleteIcon />
                              </IconButton>
                            </TableCell>
                          </StyledTableRow>
                        );
                      })
                    ) : (
                      <TableRow>
                        <TableCell colSpan={10} align="center" sx={{ py: 3 }}>
                          <Typography variant="body1" color="text.secondary">
                            No hay productos agregados
                          </Typography>
                          <Typography
                            variant="body2"
                            color="text.secondary"
                            sx={{ mt: 1 }}
                          >
                            Busque y agregue productos para comenzar la compra
                          </Typography>
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                  <TableFooter>
                    <TableRow>
                      <TableCell colSpan={10} align="right">
                        <Button
                          variant="outlined"
                          color="error"
                          startIcon={<DeleteIcon />}
                          onClick={handleDeleteAllItems}
                          disabled={itemList.length === 0 || isReadOnly}
                          sx={{ mt: 1, mb: 1 }}
                        >
                          Eliminar todos
                        </Button>
                      </TableCell>
                    </TableRow>
                  </TableFooter>
                </Table>
              </TableContainer>
            </Card>

            {/* Resumen de ítems */}
            {itemList.length > 0 && (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  mt: 2,
                  p: 2,
                  bgcolor: "white",
                  borderRadius: 2,
                  boxShadow: 1,
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Typography
                    variant="subtitle1"
                    fontWeight="bold"
                    color="#5b5b5f"
                  >
                    ITEMS:
                  </Typography>
                  <Typography
                    variant="subtitle1"
                    fontWeight="bold"
                    color="rgb(244, 177, 14)"
                  >
                    {itemList.length}
                  </Typography>
                </Box>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Typography
                    variant="subtitle1"
                    fontWeight="bold"
                    color="#5b5b5f"
                  >
                    CANTIDAD ITEMS:
                  </Typography>
                  <Typography
                    variant="subtitle1"
                    fontWeight="bold"
                    color="rgb(244, 177, 14)"
                  >
                    {cantidadItemsSelect}
                  </Typography>
                </Box>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Typography
                    variant="subtitle1"
                    fontWeight="bold"
                    color="#5b5b5f"
                  >
                    ITEMS SATISFECHOS:
                  </Typography>
                  <Typography
                    variant="subtitle1"
                    fontWeight="bold"
                    color={green[500]}
                  >
                    {
                      itemList.filter(
                        (item) =>
                          item.cantidadRecibida + (item.aRecibir || 0) ===
                          item.cantidad
                      ).length
                    }
                  </Typography>
                </Box>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Typography
                    variant="subtitle1"
                    fontWeight="bold"
                    color="#5b5b5f"
                  >
                    ITEMS INSATISFECHOS:
                  </Typography>
                  <Typography
                    variant="subtitle1"
                    fontWeight="bold"
                    color={red[500]}
                  >
                    {
                      itemList.filter(
                        (item) =>
                          item.cantidadRecibida + (item.aRecibir || 0) !==
                          item.cantidad
                      ).length
                    }
                  </Typography>
                </Box>
              </Box>
            )}
          </Grid>

          {/* Right Column - Summary and Actions */}
          <Grid item xs={12} md={3}>
            <Card elevation={3} sx={{ borderRadius: 2, mb: 2 }}>
              <CardContent>
                <Typography
                  variant="h6"
                  sx={{ mb: 2, display: "flex", alignItems: "center" }}
                >
                  <ReceiptIcon sx={{ mr: 1, color: "rgb(244, 177, 14)" }} />
                  Resumen de Compra
                </Typography>

                <Box
                  sx={{
                    backgroundColor: alpha("#f5f5f5", 0.5),
                    p: 2,
                    borderRadius: 1,
                    mb: 2,
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      mb: 1,
                    }}
                  >
                    <Typography variant="body1">Subtotal:</Typography>
                    <Typography variant="body1" fontWeight="bold">
                      {new Intl.NumberFormat("es-AR", {
                        style: "currency",
                        currency: "ARS",
                      }).format(precioTotal)}
                    </Typography>
                  </Box>

                  {existingPayments.length > 0 && (
                    <>
                      <Divider sx={{ my: 1 }} />
                      <Typography
                        variant="body2"
                        fontWeight="medium"
                        sx={{ mb: 1 }}
                      >
                        Pagos realizados:
                      </Typography>

                      {existingPayments.map((pago, index) => (
                        <Box
                          key={index}
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            ml: 2,
                            mb: 0.5,
                          }}
                        >
                          <Typography variant="body2">
                            {pago.descripcion}:
                          </Typography>
                          <Typography variant="body2">
                            {new Intl.NumberFormat("es-AR", {
                              style: "currency",
                              currency: "ARS",
                            }).format(pago.monto)}
                          </Typography>
                        </Box>
                      ))}

                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          mt: 1,
                        }}
                      >
                        <Typography variant="body2" fontWeight="medium">
                          Total pagado:
                        </Typography>
                        <Typography
                          variant="body2"
                          fontWeight="medium"
                          color="primary.main"
                        >
                          {new Intl.NumberFormat("es-AR", {
                            style: "currency",
                            currency: "ARS",
                          }).format(totalPaid)}
                        </Typography>
                      </Box>
                    </>
                  )}

                  <Divider sx={{ my: 1 }} />

                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      mt: 1,
                    }}
                  >
                    <Typography variant="h6">SALDO:</Typography>
                    <Typography
                      variant="h6"
                      fontWeight="bold"
                      color={
                        precioTotal <= totalPaid
                          ? "success.main"
                          : "rgb(244, 177, 14)"
                      }
                    >
                      {new Intl.NumberFormat("es-AR", {
                        style: "currency",
                        currency: "ARS",
                      }).format(precioTotal - totalPaid)}
                    </Typography>
                  </Box>
                </Box>

                <Box sx={{ mb: 2 }}>
                  <Typography
                    variant="subtitle1"
                    sx={{ mb: 1, display: "flex", alignItems: "center" }}
                  >
                    <PaymentIcon
                      sx={{
                        mr: 1,
                        fontSize: "small",
                        color: "rgb(244, 177, 14)",
                      }}
                    />
                    Medio de Pago
                  </Typography>

                  <Autocomplete
                    size="small"
                    disablePortal
                    disabled={isReadOnly}
                    options={tipoMedioDePago || []}
                    getOptionLabel={(option) => option.descripcion}
                    value={selectedTipoMedioDePago}
                    onChange={(event, newValue) => {
                      setSelectedTipoMedioDePago(newValue);
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Tipo de medio de pago"
                        fullWidth
                        disabled={isReadOnly}
                      />
                    )}
                    sx={{ mb: 1 }}
                  />

                  {mostrarButtonModalMedioPago && (
                    <Button
                      variant="outlined"
                      startIcon={<AddCircleOutlineIcon />}
                      onClick={handleAbrirModalMedioDePago}
                      fullWidth
                      disabled={isReadOnly}
                      sx={{ mt: 1 }}
                    >
                      Agregar Medio de Pago
                    </Button>
                  )}

                  <Collapse in={openCollapse}>
                    <Box sx={{ mt: 1 }}>
                      <Autocomplete
                        size="small"
                        disablePortal
                        disabled={isReadOnly}
                        options={medioDePagoIdTipoEspecifico || []}
                        getOptionLabel={(option) => option.descripcion}
                        value={selectedMedioDePago}
                        onChange={(event, newValue) => {
                          setSelectedMedioDePago(newValue);
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Medio de pago"
                            fullWidth
                            disabled={isReadOnly}
                          />
                        )}
                      />
                    </Box>
                  </Collapse>
                </Box>

                <Button
                  variant="contained"
                  onClick={enviarHandlePagos}
                  fullWidth
                  size="small"
                  startIcon={<ReceiptIcon />}
                  disabled={isReadOnly}
                  sx={{
                    py: 1.5,
                    borderRadius: 2,
                    fontWeight: "bold",
                    boxShadow: 3,
                    backgroundColor: "#5b5b5f",
                    color: "white",
                  }}
                >
                  ACTUALIZAR COMPRA
                </Button>

                <Button
                  variant="contained"
                  fullWidth
                  size="small"
                  onClick={enviarHandleStock}
                  disabled={isReadOnly}
                  sx={{
                    mt: 2,
                    py: 1.5,
                    borderRadius: 2,
                    fontWeight: "bold",
                  }}
                >
                  Recibir Items
                </Button>
                <Button
                  variant="outlined"
                  color="success"
                  fullWidth
                  size="small"
                  onClick={() => setShowClosedModal(true)}
                  disabled={isReadOnly}
                  sx={{
                    mt: 2,
                    py: 1.5,
                    borderRadius: 2,
                    fontWeight: "bold",
                  }}
                >
                  CERRAR
                </Button>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </form>

      {/* Modal de Medio de Pago */}
      <Modal open={openModalMedioPago} onClose={handleCloseModalMedioPago}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 480,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 3,
            borderRadius: 2,
            overflow: "hidden",
          }}
        >
          <IconButton
            onClick={handleCloseModalMedioPago}
            disabled={isReadOnly}
            sx={{
              position: "absolute",
              top: 12,
              right: 12,
              color: "grey.500",
            }}
          >
            <CloseIcon />
          </IconButton>

          <Typography
            variant="h6"
            component="h2"
            sx={{ textAlign: "center", color: "primary.main", mb: 2 }}
          >
            Selección de Medio de Pago
          </Typography>
          <Divider sx={{ mb: 3 }} />

          <Box display="flex" alignItems="center" gap={2} mb={2}>
            <Autocomplete
              size="small"
              disablePortal
              disabled={isReadOnly}
              options={tipoMedioDePago || []}
              getOptionLabel={(option) => option.descripcion}
              value={modalTipoMedioDePagoSeleccionado}
              onChange={(event, newValue) =>
                setModalTipoMedioDePagoSeleccionado(newValue)
              }
              sx={{ width: "100%" }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Tipo de medio de pago"
                  disabled={isReadOnly}
                />
              )}
            />

            <Autocomplete
              size="small"
              disablePortal
              disabled={isReadOnly}
              options={(medioDePagoIdTipoEspecifico || []).map((it) => ({
                label: it.descripcion,
                id: it.id,
              }))}
              onChange={(event, newValue) => {
                if (newValue) {
                  setModalMedioDePagoSeleccionado(newValue.label);
                  setModalMedioDePagoSeleccionadoID(newValue.id);
                } else {
                  setModalMedioDePagoSeleccionado(null);
                  setModalMedioDePagoSeleccionadoID(null);
                }
              }}
              sx={{ width: "100%" }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Medio de Pago"
                  disabled={isReadOnly}
                />
              )}
            />
          </Box>

          <Box display="flex" alignItems="center" gap={2}>
            <TextField
              label="Cantidad a pagar"
              variant="outlined"
              sx={{ flexGrow: 1 }}
              value={modalMedioDePagoCantidad}
              onChange={(e) => setModalMedioDePagoCantidad(e.target.value)}
              disabled={isReadOnly}
            />
            <IconButton
              onClick={handleAddNuevoMedioDePago}
              color="primary"
              disabled={isReadOnly}
              sx={{ color: "rgb(244, 177, 14)" }}
            >
              <AddCircleOutlineIcon />
            </IconButton>
          </Box>

          <Box
            sx={{
              backgroundColor: "#f9f9f9",
              borderRadius: 2,
              padding: 2,
              boxShadow: 1,
              mt: 3,
            }}
          >
            <Stack spacing={2}>
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <Typography variant="subtitle1" fontWeight="bold">
                  TOTAL
                </Typography>
                <Typography variant="subtitle1">
                  {new Intl.NumberFormat("es-AR", {
                    style: "currency",
                    currency: "ARS",
                  }).format(precioTotal)}
                </Typography>
              </Box>

              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <Typography variant="subtitle1" fontWeight="bold">
                  PAGOS EXISTENTES
                </Typography>
                <Typography variant="subtitle1" color="primary.main">
                  {new Intl.NumberFormat("es-AR", {
                    style: "currency",
                    currency: "ARS",
                  }).format(totalPaid)}
                </Typography>
              </Box>

              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <Typography variant="subtitle1" fontWeight="bold">
                  NUEVOS PAGOS
                </Typography>
                <Typography variant="subtitle1" color="success.main">
                  {new Intl.NumberFormat("es-AR", {
                    style: "currency",
                    currency: "ARS",
                  }).format(cantidaMedioDePagoList - totalPaid)}
                </Typography>
              </Box>

              <Divider sx={{ my: 1 }} />

              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <Typography variant="subtitle1" fontWeight="bold">
                  SALDO
                </Typography>
                <Typography
                  variant="body2"
                  color={
                    precioTotal <=
                    totalPaid + (cantidaMedioDePagoList - totalPaid)
                      ? "success.main"
                      : "text.secondary"
                  }
                  textAlign="center"
                >
                  {new Intl.NumberFormat("es-AR", {
                    style: "currency",
                    currency: "ARS",
                  }).format(
                    precioTotal -
                      totalPaid -
                      (cantidaMedioDePagoList - totalPaid)
                  )}
                </Typography>
              </Box>
            </Stack>
          </Box>

          {existingPayments.length > 0 && (
            <Typography
              variant="body2"
              color="info.main"
              sx={{ mt: 2, textAlign: "center" }}
            >
              Esta compra ya tiene pagos registrados por un total de{" "}
              {new Intl.NumberFormat("es-AR", {
                style: "currency",
                currency: "ARS",
              }).format(totalPaid)}
            </Typography>
          )}

          <Typography
            variant="subtitle1"
            sx={{
              mt: 2,
              mb: 1,
              textAlign: "center",
              color: "text.secondary",
            }}
          >
            Lista de Medios de Pago Seleccionados
          </Typography>
          <Box
            sx={{
              maxHeight: 150,
              overflowY: "auto",
              backgroundColor: "#fafafa",
              padding: 2,
              borderRadius: 1,
            }}
          >
            {medioDePagoList.map((it, index) => (
              <Box
                key={index}
                display="flex"
                alignItems="center"
                justifyContent="space-between"
                sx={{
                  mb: 1,
                  p: 1,
                  backgroundColor: "#f0f0f0",
                  borderRadius: 1,
                }}
              >
                <Typography variant="body2">{it.descripcion}</Typography>
                <Typography variant="body2">
                  {new Intl.NumberFormat("es-AR", {
                    style: "currency",
                    currency: "ARS",
                  }).format(it.monto)}
                </Typography>

                <IconButton
                  edge="end"
                  onClick={() => handleDeleteMedioDePago(index, it.monto)}
                  disabled={isReadOnly}
                  sx={{ color: "rgb(244, 177, 14)" }}
                >
                  <DeleteIcon />
                </IconButton>
              </Box>
            ))}
          </Box>
        </Box>
      </Modal>

      {/* Modal de Factura */}
      {openModal && (
        <ModalFacturaComponent
          open={openModal}
          handleClose={handleCloseModal}
          transaccionData={transaccionData}
          itemsTransaccion={itemList}
          entidadParaFactura={entidadFactura}
          usuarioParaFactura={null}
          tipoDeFactura={true}
          deDondeViene={"compra"}
        />
      )}

      {/* Modal para marcar como incompleta */}
      {/* <Modal open={showIncompleteModal} onClose={() => setShowIncompleteModal(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            borderRadius: 2,
          }}
        >
          <Typography variant="h6" component="h2" sx={{ mb: 2 }}>
            Confirmar acción
          </Typography>
          <Typography sx={{ mb: 3 }}>¿Está seguro que desea marcar esta compra como INCOMPLETA?</Typography>
          <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2 }}>
            <Button variant="outlined" onClick={() => setShowIncompleteModal(false)}>
              Cancelar
            </Button>
            <Button
              variant="contained"
              color="error"
              onClick={() => {
                setShowIncompleteModal(false)
                handleMarkIncomplete()
              }}
            >
              Confirmar
            </Button>
          </Box>
        </Box>
      </Modal> */}

      {/* Modal para marcar como cerrada */}
      <Modal open={showClosedModal} onClose={() => setShowClosedModal(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            borderRadius: 2,
          }}
        >
          <Typography variant="h6" component="h2" sx={{ mb: 2 }}>
            Confirmar acción
          </Typography>
          <Typography sx={{ mb: 3 }}>
            ¿Está seguro que desea cerrar la compra?
          </Typography>
          <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2 }}>
            <Button
              variant="outlined"
              onClick={() => setShowClosedModal(false)}
            >
              Cancelar
            </Button>
            <Button
              variant="contained"
              color="success"
              onClick={() => {
                setShowClosedModal(false);
                handleMarkClosed();
              }}
            >
              Confirmar
            </Button>
          </Box>
        </Box>
      </Modal>

      {/* Modal para confirmar cierre automático */}
      {/* <Modal
  open={showClosedConfirmModal}
  onClose={() => setShowClosedConfirmModal(false)}
>
  <Box
    sx={{
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: 400,
      bgcolor: "background.paper",
      boxShadow: 24,
      p: 4,
      borderRadius: 2,
    }}
  >
    <Typography variant="h6" component="h2" sx={{ mb: 2 }}>
      La compra cumple los requisitos para ser cerrada
    </Typography>
    <Typography sx={{ mb: 3 }}>
      Esta compra cumple con los requisitos para ser marcada como CERRADA.
      ¿Desea cerrarla ahora?
    </Typography>
    <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2 }}>
      <Button
        variant="outlined"
        color="error"
        onClick={() => {
          setShowClosedConfirmModal(false);
          // Cancelar: no se realiza ningún cambio
        }}
      >
        Cancelar
      </Button>
      <Button
        variant="outlined"
        onClick={async () => {
          setShowClosedConfirmModal(false);
          await convertirSinCerrar();
        }}
      >
        No cerrar
      </Button>
      <Button
        variant="contained"
        color="success"
        onClick={async () => {
          setShowClosedConfirmModal(false);
          //await cerrarCompra();
        }}
      >
        Cerrar compra
      </Button>
    </Box>
  </Box>
</Modal> */}
    </Box>
  );
};

export default EditarCompraComponent;
